/* eslint-disable */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { decode as base64_decode } from 'base-64';

function History({en_data, id_data, language}) {

  return (
    <>
      <div className='content mb-3'>
        <div className='col-our-office-location'>
          <div className='container'>
            <div className='row'>
                <div className='col-md-12'>
                {language === 'EN' &&
                <div
                    dangerouslySetInnerHTML={{
                    __html: decodeURIComponent(
                        escape(en_data ? base64_decode(en_data) : '')
                    ),
                    }}
                ></div>
                }
                {language === 'ID' &&
                <div
                    dangerouslySetInnerHTML={{
                    __html: decodeURIComponent(
                        escape(id_data ? base64_decode(id_data) : '')
                    ),
                    }}
                ></div>
                }
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default History;
